import { gql } from "@apollo/client";

const GET_FECHAS_PERMITIDAS_JUSTIFICACION = gql`
query GetFechasPermitidasJustificaciones($idEvaluacion: Int!, $idProfesional: Int!) {
    allowedDatesJustificacion(idEvaluacion: $idEvaluacion, idProfesional: $idProfesional) 
}`;

export default GET_FECHAS_PERMITIDAS_JUSTIFICACION;